module.exports = __webpack_public_path__ + "static/ulresearchinst_logo_horz_wht_rgb -7293dd515e85450d25ce2c28dc125fc1.png";